import React from 'react';
import QuantitativeChart from './QuantitativeChart';

const MeasurementUnitBasedComponentMap = {
    //2: XComponent, // XComponent is a component that is used for measurement unit 2 
};

const IndicatorUUIDBasedComponentMap = {
    // 'uuid': XComponent, // XComponent is a component that is used for a specific indicator
};

const DefaultComponent = QuantitativeChart;

const QuantitativeChartFactory = ({ indicatorDTO, objective }) => {
    // console.log('QuantitativeChartFactory', objective);
    const IndicatorUUIDComponent = IndicatorUUIDBasedComponentMap[indicatorDTO.indicatorUUID];
    if (IndicatorUUIDComponent) {
        return <IndicatorUUIDComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }
    const MeasurementUnitComponent = MeasurementUnitBasedComponentMap[indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnitId];
    if (MeasurementUnitComponent) {
        return <MeasurementUnitComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }
    return <DefaultComponent indicatorDTO={indicatorDTO} objective={objective} />;
};

export default QuantitativeChartFactory;